import { createContext as s } from "react";
const a = s({
  isXs: !1,
  isSm: !1,
  isMd: !1,
  isLg: !1,
  isXl: !1,
  is2xl: !1,
  isMobile: !1,
  isTablet: !1,
  isDesktop: !1
});
export {
  a as BreakpointContext,
  a as default
};
